import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingServicedeskRovoServiceRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingServicedeskRovoServiceRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { servicedeskResolutionManagementPageEntrypoint } from './ui/service-desk-resolution-management/servicedeskResolutionManagementPageEntrypoint.tsx';

export const projectSettingServicedeskRovoServiceRouteEntry: ReturnType<typeof createEntry> =
	createEntry(projectSettingServicedeskRovoServiceRoute, () => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-rovo-service-settings',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			fg('enable-rovo-settings-revamp')
				? servicedeskResolutionManagementPageEntrypoint
				: notFoundPageEntrypoint,

		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		perfMetricKey: 'jsm-rovo-service-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}));
